import React from 'react'
import { CarbannerSearchIcon } from '../../../Utils/svgUrlConstant'
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from 'react-redux';
import { setPlace } from '../../../Redux/Action/Action';
import { useForm } from 'react-hook-form';
import hotelrentbg from '../../../assets/images/hotel-rent-bg.png'
import planetakeoff from '../../../assets/images/plane-takeoff.svg'
import mappinhouse from '../../../assets/images/map-pin-house.svg'

export const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
};

export const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
};

export const getDateAfterDays = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
};


export default function CarRentalBanner() {
    const place = useSelector((state) => state.place);
    const localSelectedCity = localStorage.getItem('selectedCity');
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        formState: { errors },
    } = useForm({
        defaultValues: {
            departureCity: "",
            destination: "",
            checkInDate: getTodayDate(),
            pickupTime: getCurrentTime(),
            dropOffDate: getDateAfterDays(3),
            dropOffTime: getCurrentTime(),
        },
    });

    /** --------------- HANDLE SEARCH SUBMIT ---------------- */
    const onSubmit = (data) => {
        console.log("Final Car Rental Search Data:", data);
    };

    return (
        <section className="section-equal-padding hotel-hero-sec uk-scrollspy-inview"
            style={{
                backgroundImage: `url(${hotelrentbg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container">
                <div className="slider-content text-center mx-auto">
                    <h1>Car Rentals</h1>
                </div>
                <div className="search-wrapper flight-search-wrpaaer bg-white d-block">
                    <form className="flight-booking-form" onSubmit={handleSubmit(onSubmit)}>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab" tabIndex="0">
                                <div className="booking-search-form">
                                    <div className="row gy-3">
                                        <div className="col-md-6">
                                            <div className="search-item">
                                                <label className="form-label">Departure city?</label>
                                                <div
                                                    className="search-control-wrapper input-group custom-input d-flex align-items-center">
                                                    <span><img src={planetakeoff} alt="" /></span>
                                                    <Autocomplete
                                                        className="ps-2 form-control border-0 outline-0 shadow-none p-0"
                                                        apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                        placeholder="Enter Departure City"
                                                        onPlaceSelected={(city) => {
                                                            if (!city || !city.formatted_address) return;

                                                            const selectedCity = city.formatted_address.split(",")[0];

                                                            setValue("departureCity", selectedCity, {
                                                                shouldValidate: true,
                                                            });
                                                            trigger("departureCity");
                                                        }}
                                                    />
                                                    <input
                                                        type="hidden"
                                                        {...register("departureCity", { required: "Destination is required" })}
                                                    />
                                                </div>
                                                {errors.departureCity && (
                                                    <p className="text-danger small">{errors.departureCity.message}</p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="search-item">
                                                <label className="form-label">Destination</label>
                                                <div
                                                    className="search-control-wrapper input-group custom-input d-flex align-items-center">
                                                    <span><img src={mappinhouse} alt="" /></span>
                                                    <Autocomplete
                                                        className="ps-2 form-control border-0 outline-0 shadow-none p-0"
                                                        apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                        placeholder={
                                                            localSelectedCity && localSelectedCity !== "undefined" && place
                                                                ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                                : "Where would you like to go"
                                                        }

                                                        onPlaceSelected={async (city) => {
                                                            const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                                            // Update route
                                                            if (!city) return;
                                                            const cityName = city.formatted_address.split(",")[0];
                                                            setValue("destination", cityName, { shouldValidate: true });
                                                            trigger("destination");

                                                            // Dispatch Redux actions
                                                            dispatch(setPlace(selectedCity));
                                                            localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                                                        }}
                                                    />
                                                    <input
                                                        type="hidden"
                                                        {...register("destination", { required: "Destination is required" })}
                                                    />
                                                </div>
                                                {errors.destination && (
                                                    <p className="text-danger small">{errors.destination.message}</p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="car_rentals_form">
                                            <div className="car_rentals_form_inner">
                                                <label className="form-label">Check-In</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    {...register("checkInDate", { required: "Check-In-Date is required" })}
                                                />
                                                {errors.checkInDate && (
                                                    <p className="text-danger small">{errors.checkInDate.message}</p>
                                                )}
                                            </div>
                                            <div className="car_rentals_form_inner">
                                                <label className="form-label">Pick-up time</label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    {...register("pickupTime", { required: "Pickup-Time is required" })}
                                                />
                                                {errors.pickupTime && (
                                                    <p className="text-danger small">{errors.pickupTime.message}</p>
                                                )}
                                            </div>
                                            <div className="car_rentals_form_inner">
                                                <label className="form-label">Drop-off date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    {...register("dropOffDate", { required: "Drop-Off-Date is required" })}
                                                />
                                                {errors.dropOffDate && (
                                                    <p className="text-danger small">{errors.dropOffDate.message}</p>
                                                )}
                                            </div>
                                            <div className="car_rentals_form_inner">
                                                <label className="form-label">Drop-off time</label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    {...register("dropOffTime", { required: "Drop-Off-Time is required" })}
                                                />
                                                {errors.dropOffTime && (
                                                    <p className="text-danger small">{errors.dropOffTime.message}</p>
                                                )}
                                            </div>
                                            <button
                                                type="submit"
                                                className="view-all-btn justify-content-center gap-2 align-items-center mt-auto">
                                                <CarbannerSearchIcon />
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab" tabIndex="0">
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
}
